"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifySingleDetailTypes = void 0;
// string enum with cost,issueDate, credentialType,duration,level,expireDate
var VerifySingleDetailTypes;
(function (VerifySingleDetailTypes) {
    VerifySingleDetailTypes["COST"] = "cost";
    VerifySingleDetailTypes["ISSUE_DATE"] = "issueDate";
    VerifySingleDetailTypes["CREDENTIAL_TYPE"] = "credentialType";
    VerifySingleDetailTypes["DURATION"] = "duration";
    VerifySingleDetailTypes["LEVEL"] = "level";
    VerifySingleDetailTypes["EXPIRE_DATE"] = "expireDate";
})(VerifySingleDetailTypes = exports.VerifySingleDetailTypes || (exports.VerifySingleDetailTypes = {}));
